import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import extend from 'lodash/extend';
import uniqueId from 'lodash/uniqueId';
import omit from 'lodash/omit';
import { bindActionCreators } from 'redux';
import { connect } from '../../../react-redux';
import * as editingActionCreators from '../../../actions/editing';

// ==============================================================

// two components which are composed to enable editing actions

// component one: connect to redux store for state & action creators
// component two: filter state, apply unique component ID to
// actions, render component

// ==============================================================

var connectToEditStore = function connectToEditStore(ComposedComponent) {
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      editingActions: bindActionCreators(editingActionCreators, dispatch)
    };
  };
  var mapStateToProps = function mapStateToProps(state) {
    return {
      editing: state.get('editing')
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(ComposedComponent);
};
var giveEditProps = function giveEditProps(ComposedComponent) {
  var _Class;
  return _Class = /*#__PURE__*/function (_Component) {
    function _Class() {
      var _this;
      _classCallCheck(this, _Class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _Class, [].concat(args));
      _defineProperty(_this, "switchOnEditing", function () {
        var initialFocusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        _this.props.editingActions.startEdit(_this.uniqueId(), initialFocusId);
      });
      _defineProperty(_this, "switchOffEditing", function () {
        _this.props.editingActions.endEdit(_this.uniqueId());
      });
      _defineProperty(_this, "toggleEditing", function () {
        _this.props.editingActions.toggleEditing(_this.uniqueId());
      });
      return _this;
    }
    _inherits(_Class, _Component);
    return _createClass(_Class, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this._uniqId = uniqueId("".concat(ComposedComponent.displayName, "_"));
      }
    }, {
      key: "uniqueId",
      value: function uniqueId() {
        return this.props.guid || this._uniqId;
      }
    }, {
      key: "propsForChild",
      value: function propsForChild() {
        var uniqueId = this.uniqueId();
        var editingProps = {
          isEditing: !!this.props.editing.get(uniqueId),
          editingKey: uniqueId,
          switchOnEditing: this.switchOnEditing,
          switchOffEditing: this.switchOffEditing,
          toggleEditing: this.toggleEditing
        };

        // Don't inject the `editing` prop in, or else all editable
        // components will have to rerender when one switches editing
        // on/off.
        return omit(extend({}, editingProps, this.props), ['editing']);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(ComposedComponent, this.propsForChild());
      }
    }]);
  }(Component), _defineProperty(_Class, "propTypes", {
    editing: ImmutablePropTypes.map,
    editingActions: PropTypes.shape({
      startEdit: PropTypes.func.isRequired,
      endEdit: PropTypes.func.isRequired,
      toggleEditing: PropTypes.func.isRequired
    }).isRequired,
    guid: PropTypes.string
  }), _defineProperty(_Class, "displayName", ComposedComponent.displayName), _defineProperty(_Class, "defaultProps", {
    editing: fromJS({}),
    guid: null
  }), _Class;
};
export var makeEditable = function makeEditable(givenComponent) {
  return connectToEditStore(giveEditProps(givenComponent));
};
export default makeEditable;